import React from 'react';

// components
import CommonSidebar from "../Common/CommonSidebar";
import TaskCreateModal from "../Task/TaskCreateModal";

//icons
import AssignmentIcon from '@mui/icons-material/Assignment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArchiveIcon from '@mui/icons-material/Archive';
import ListIcon from "@mui/icons-material/List";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import retrievePermission from "../../utils/retrievePermission";


class TaskSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            reportPermission: false,
        };
    }

    async componentDidMount() {
        await this.retrieveReportPermission();
    }

    async retrieveReportPermission(){
        let p = 0;
        p += await retrievePermission(
            'CalculatorViewSet',
            'safe_report',
            this.context.subscriberObject
        );
        p += await retrievePermission(
            'EmployeeViewSet',
            'safe_report',
            this.context.subscriberObject
        );
        if (p > 1){
            this.setState(
                {
                    reportPermission: true
                }
            );
        }
    }

    render() {
        let groups = [
            {
                title: 'Бизнес-процессы',
                items: [
                    {
                        title: 'Мои',
                        link: '/delivery/my/',
                        icon: ListIcon,
                    },
                    {
                        title: 'Коллег',
                        link: '/delivery/subordinate/',
                        icon: ListIcon,
                    },
                ],
            },
            {
                title: 'Маршруты',
                items: [
                    {
                        title: 'Мои',
                        link: '/route/my/',
                        icon: ListIcon,
                    },
                    {
                        title: 'Коллег',
                        link: '/route/subordinate/',
                        icon: ListIcon,
                    },
                ],
            },
            {
                title: 'Задачи',
                items: [
                    {
                        type: 'component',
                        component: <TaskCreateModal
                            account={null}
                            opportunity={null}
                            phase={null}
                            activeStep={0}
                            lockedSteps={[]}
                        />
                    },
                    // {
                    //     title: 'Моя доска',
                    //     link: '/task/my/',
                    //     icon: AssignmentIcon,
                    // },
                    // {
                    //     title: 'Доска по коллегам',
                    //     link: '/task/owner/',
                    //     icon: AssignmentIcon,
                    // },
                    {
                        title: 'Мой календарь',
                        link: '/task/mycalendar/',
                        icon: CalendarMonthIcon,
                    },
                    {
                        title: 'Мои завершенные',
                        link: '/task/completed/',
                        icon: ArchiveIcon,
                    },
                    {
                        title: 'Завершенные коллег',
                        link: '/task/ownercompleted/',
                        icon: ArchiveIcon,
                    },
                ],
            }
        ]
        if (this.state.reportPermission){
            groups.push(
                {
                    title: 'Анализ',
                    items: [
                        {
                            title: 'Загрузка',
                            link: '/task/report/',
                            icon: DeveloperBoardIcon,
                        },
                    ]
                }
            )
        }
        return(
            <CommonSidebar
                groups={groups}
            />
        )
    }
}

export default TaskSidebar;
